import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { ICatalogoInseguroDTO } from "../../../../../Interfaces/hazard/IHazard";
import { UsePanelEditarCatalogo } from "./UsePanelEditarCatalogo";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { TextField } from "@fluentui/react";

export  interface IPanelEditarCatalogo extends IOpenPanel{
    item:ICatalogoInseguroDTO
}
export const PanelEditarCatalogo=(props:IPanelEditarCatalogo)=>{
    const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelEditarCatalogo(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Editar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={putEditarCatalogo}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [request]
      );
      return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Editar Catalogo"} 
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
           <TextField 
           type="text"
           label="Nombre de Catalogo"
           placeholder="Ingrese Nombre de Catalogo"
           autoComplete="off"
           value={request.nombreCatalogo}
           onChange={(event,newValue)=>{
              if(newValue!=null){
              setRequest({...request,nombreCatalogo:newValue})}
           }}
           />
        </PanelDrawer>
     )

}